import React from 'react';
import { Field as AkField } from '@atlaskit/form';
import AkSelect from '@atlaskit/select';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import { HOLIDAY_FREQUENCY_PREFIX } from '../../../../../../../common/ui/constants.tsx';
import messages from './messages';

type Props = {
	isRecurring: boolean;
} & Intl & {
		fieldId: number | string;
	};

export const FrequencyView = ({ intl: { formatMessage }, fieldId, isRecurring = true }: Props) => {
	const frequencyOptions = [
		{ label: formatMessage(messages.annually), value: true },
		{ label: formatMessage(messages.oneTime), value: false },
	];

	return (
		<AkField
			name={`${HOLIDAY_FREQUENCY_PREFIX}${fieldId}`}
			label={formatMessage(messages.frequency)}
			defaultValue={frequencyOptions.find(({ value }) => value === isRecurring)}
		>
			{/* @ts-expect-error - TS2322 - Type '{ options: { label: string; value: boolean; }[]; isRequired: boolean; isDisabled: boolean; isInvalid: boolean; onChange: (value: FormEvent<HTMLInputElement> | { label: string; value: boolean; }) => void; ... 5 more ...; 'aria-labelledby': string; }' is not assignable to type 'Readonly<SelectProps<{ label: string; value: boolean; }, false>>'. */}
			{({ fieldProps: { id, ...rest } }) => <AkSelect {...rest} options={frequencyOptions} />}
		</AkField>
	);
};

export const Frequency = injectIntl(FrequencyView);
